import { Button, Card, Col, Row, Typography } from 'antd';
import { StyleSheet } from "../StyleSheet";
import { useEffect, useState } from 'react';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { CentersPayment } from '../types/common';
const { Text } = Typography;

interface ItemNavigateOptionsProps {
    label: string;
    children: Array<CentersPayment>;
    openCard: Function;
    onClick: Function;
    isOpen: boolean;
}

const ListItemAccordion = (props: ItemNavigateOptionsProps) => {
    const { label, children, openCard, onClick, isOpen } = props;
    const [desplegable, setDesplegable] = useState(false);

    useEffect(() => {
        setDesplegable(isOpen);
    }, [isOpen]);

    return (
        <>
            <div onClick={() => onClick()} style={{ cursor: 'pointer' }}>
                <Card
                    style={styles.viewRoot}
                    bodyStyle={styles.bodyCard}
                >
                    <Text style={{ flex: 1, color: '#797e84' }}>{label}</Text>
                    <Button
                        icon={!desplegable ? <RightOutlined style={{ color: '#797e84' }} /> : <DownOutlined style={{ color: '#797e84' }} />}
                        type="text"
                        onClick={() => setDesplegable(!desplegable)} />
                </Card>
            </div>
            <div style={{ width: '97%' }}>
                {desplegable ? (
                    <Row>
                        {children.map((element, index) => (
                            <Col xs={12} xl={12} key={index} style={styles.columnItem}>
                                <div onClick={() => {
                                    openCard(element);
                                }} style={{ cursor: 'pointer' }}>
                                    <Card style={styles.viewRoot} bodyStyle={styles.bodyCard}>
                                        <Col xs={18} xl={16} style={styles.imageContainer}>
                                            <img style={styles.imageStyle} src={element.image_url} alt={label} />
                                        </Col>
                                        <Col xs={6} xl={8} style={styles.buttonContainer}>
                                            <RightOutlined style={{ color: '#797e84', fontSize: 16 }} />
                                        </Col>
                                    </Card>
                                </div>
                            </Col>
                        ))}
                    </Row>
                ) : null}
            </div>
        </>

    );
};

const styles = StyleSheet.create({
    viewRoot: {
        width: "95%",
        display: 'flex',
        alignItems: 'center',
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 12,
        marginBottom: 10
    },
    bodyCard: {
        width: "100%",
        height: 60,
        display: 'flex',
        alignItems: 'center',
        padding: 10
    },
    columnItem: {
        width: '50%',
        paddingLeft: 1,
    },
    imageContainer: {
        width: "70%",
        display: 'flex',
        justifyContent: 'flex-start',
        marginLeft: 10,
        flex: 1,
        padding: 0
    },
    buttonContainer: {
        width: 30,
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 10
    },
    imageStyle: {
        width: "90%",
        height: 40,
        paddingLeft: 5,
    }
});

export default ListItemAccordion;
